import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router"
import { loadUserLogin } from "../../../../../service/userManagementAction.js"
import { useHistory } from "react-router-dom"
import { formatterRowComponent } from "../../../../../../component/atoms/Tabel/index.jsx"
import { sortCaret } from "../../../../../../_metronic/_helpers/index.js"
import { timeStampToDate } from "../../../../../helpers/DateHelper.js"
import { stringFormatting, convertM2ToHectare, toMeter } from "../../../../../helpers/TextHelper.js"
import { Button, Card } from "react-bootstrap"
import { CardBody } from "../../../../../../_metronic/_partials/controls/index.js"
import { EmptyCard, TableSkeleton, TableView } from "../../../../../../component/index.jsx"
import { RoutesConstants } from "../../../../../../constants/RoutesConstants.js"
import { linkWithCtrl } from "../../../../../helpers/Utils.js"
import React, { useEffect, useState } from "react"
import { GetListInitDataFormApproveBulk } from "../../../../../../redux/actions/OrderAction.jsx"
import { PRIVILEGE_ENUM } from "../../../../../../constants/PrivilegeConstants.js"

export const SprayingPascaTanamPending = ({ changePage, activeFilter, data }) => {
  const { t } = useTranslation()
  const { General, Order } = useSelector((state) => state)
  const params = useParams()
  const privileges = loadUserLogin().privilege
  const history = useHistory()
  const [selectedRows, setSelectedRows] = useState([])
  const [listDataSelected, setListDataSelected] = useState([])
  const [listIdOrderSelected, setListIdOrderSelected] = useState([])
  const [areaHectare, setAreaHectare] = useState(0)
  const dispatch = useDispatch()

  useEffect(() => {
    if (listDataSelected) {
      const listAreaLand = listDataSelected.map((item) => {
        return item?.land_area
      })
      if (listAreaLand.length) {
        const sumArea = listAreaLand.reduce((a, b) => a + b)
        const listData = listDataSelected.map((item) => {
          return item?.id
        })

        setListIdOrderSelected(listData)
        setAreaHectare(convertM2ToHectare(sumArea))
      } else {
        setListIdOrderSelected([])
        setAreaHectare(0)
      }
    }
  }, [listDataSelected])

  useEffect(() => {
    if (Order?.listDataInitFormApproveBulk) {
      history.push(RoutesConstants.ORDER.APPROVAL_BULK_PASCA_TANAM())
    }
  }, [Order?.listDataInitFormApproveBulk])

  function onClickApproveBulk() {
    if (listIdOrderSelected.length) {
      dispatch(GetListInitDataFormApproveBulk({ order_id_list: listIdOrderSelected }))
    }
  }

  useEffect(() => {
    setListDataSelected(selectedRows)
  }, [selectedRows])

  const columns = [
    {
      dataField: "plantingSeason.area.name",
      text: t("table_header_area_name"),
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiCode
      },
      headerStyle: () => {
        return { width: "20%" }
      },
      sortCaret: sortCaret
    },
    {
      dataField: "mitra",
      text: t("table_header_mitra"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiMitra
      },
      sortCaret: sortCaret
    },
    {
      dataField: "farmer",
      text: t("table_header_farmer"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiFarmer
      },
      sortCaret: sortCaret
    },
    {
      dataField: "activity_name",
      text: t("table_header_activity_type"),
      sort: false,
      formatter: formatterRowComponent,
      sortCaret: sortCaret,
      headerStyle: () => {
        return { width: "20%" }
      },
      formatExtraData: {
        externalStyle: uiActivity
      }
    },
    {
      dataField: "createdDate",
      text: t("table_header_created_date"),
      sort: true,
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiDate
      }
    },
    {
      dataField: "plant_age",
      text: t("table_header_plant_age"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiHST
      },
      sortCaret: sortCaret
    },
    {
      dataField: "submit_by",
      text: t("table_header_submit_by"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiUser
      },
      sortCaret: sortCaret
    }
  ]

  function uiHST(e) {
    return (
      <>
        <div>{stringFormatting(e?.hst)} HST</div>
      </>
    )
  }

  function uiUser(e) {
    return (
      <>
        <div className={"text-dark font-weight-bolder  font-size-lg"}>
          {stringFormatting(e?.scheduler_name)}
        </div>
        <div>{stringFormatting(e?.scheduler_role)}</div>
      </>
    )
  }

  function uiCode(e) {
    return (
      <>
        <div className={"text-dark font-weight-bolder  font-size-lg"}>
          {stringFormatting(e?.area_name)}
        </div>
        <div className={"d-flex"}>
          <div>{stringFormatting(e?.sub_district)},&nbsp;</div>
          <div>{toMeter(e?.land_area)}</div>
        </div>
      </>
    )
  }

  function uiDate(e) {
    return (
      <div>
        <div>{e?.created_date ? timeStampToDate(e?.created_date, "dd-MM-yyyy") : "-"}</div>
        <div>{e?.created_date ? timeStampToDate(e?.created_date, "HH:mm:ss") : "-"}</div>
      </div>
    )
  }

  function uiMitra(e) {
    return (
      <div>
        <div className={"text-dark font-weight-bolder  font-size-lg mb-1"}>
          {stringFormatting(e?.mitra_name)}
        </div>
        <div>{stringFormatting(e?.mitra_code)}</div>
      </div>
    )
  }

  function uiFarmer(e) {
    return (
      <div>
        <div className={"text-dark font-weight-bolder  font-size-lg mb-1"}>
          {stringFormatting(e?.farmer_name)}
        </div>
        <div>{stringFormatting(e?.farmer_code)}</div>
      </div>
    )
  }

  function uiActivity(e) {
    return (
      <div>
        <div className={"text-dark font-weight-bolder font-size-lg"}>
          {stringFormatting(e?.activity_name)}
        </div>
      </div>
    )
  }

  return (
    <div>
      <Card>
        <CardBody>
          {General.loading ? (
            <TableSkeleton column={6} row={10} />
          ) : data?.pageData?.length === 0 ? (
            <EmptyCard
              body={
                activeFilter
                  ? t("messages_response_data_not_found")
                  : t("messages_response_empty_state", { name: "penyemprotan" })
              }
            />
          ) : (
            ""
          )}
          <TableView
            dataTable={data?.pageData ?? []}
            loadingGetData={false}
            callbackAfterPageChange={changePage}
            columnProperties={columns}
            currentPage={data?.page?.currentPage}
            currentElement={data?.page?.currentElement}
            totalCount={data?.page?.totalCount}
            rowClasses={() => {
              return "cursor-pointer"
            }}
            keyField={"id"}
            selectable={true}
            onSelect={(row, isSelected) => {
              let rows = JSON.parse(JSON.stringify(selectedRows))
              if (isSelected) {
                rows.push(row)
              } else {
                rows = rows.filter((e) => e?.id != row?.id)
              }
              setSelectedRows(rows)
            }}
            onSelectAll={(isSelect, rows) => {
              let rowses = JSON.parse(JSON.stringify(selectedRows))
              if (isSelect) {
                if (rows?.length > 0) {
                  rows?.map((e) => {
                    rowses.push(e)
                  })
                }
              } else {
                if (rows?.length > 0) {
                  let rowsesNew = rowses
                  rows?.map((row) => {
                    const removeIndex = rowses.findIndex((e) => e?.mitra_id === row?.mitra_id)
                    // remove object
                    rowsesNew.splice(removeIndex, 1)
                  })
                  rowses = rowsesNew
                }
              }
              setSelectedRows(rowses)
            }}
            rowEvents={{
              onClick: (e, row) => {
                if (privileges.indexOf(PRIVILEGE_ENUM.DETAIL_ORDER)) {
                  const url = RoutesConstants.ORDER.DETAIL_PASCA_PLANTING(params?.tab, row?.id)
                  if (e.ctrlKey) {
                    linkWithCtrl(url)
                  } else {
                    history.push(url)
                  }
                }
              }
            }}
          />
        </CardBody>
      </Card>
      {listIdOrderSelected?.length > 1 ? (
        <div className={"w-full d-flex mt-10 mb-6"}>
          <Button onClick={onClickApproveBulk}>
            Approve Bulk ({`${listIdOrderSelected.length} Selected, ${areaHectare} Ha`}){" "}
          </Button>
        </div>
      ) : (
        ""
      )}
    </div>
  )
}